import { render, staticRenderFns } from "./ImprimirFavs.vue?vue&type=template&id=7743f0f4&scoped=true&lang=html&"
import script from "./ImprimirFavs.vue?vue&type=script&lang=js&"
export * from "./ImprimirFavs.vue?vue&type=script&lang=js&"
import style0 from "./ImprimirFavs.vue?vue&type=style&index=0&id=7743f0f4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7743f0f4",
  null
  
)

export default component.exports